<template>
    <div class="w-full h-full p-2">
        <div
            class="flex flex-row gap-2 cursor-pointer w-36 mb-3"
            @click="handleGoBack">
            <hi-arrow-left-icon
                class="close-button w-7 h-7"
                aria-hidden="true" />
            <h3>
                {{ $t('labels.back') }}
            </h3>
        </div>
        <select-routing
            v-if="!isShowMapRouting"
            :routing-info="routingInfo"
            @click="(data: any) => handleShowMapRouting(data)" />
        <map-routing
            v-else
            :routing-option="routingInfo"
            action="create" />
    </div>
</template>
<script setup lang="ts">
import SelectRouting from './ignore/screen/select-routing.vue'
import MapRouting from './ignore/screen/map-routing.vue'

definePageMeta({
  layout: 'full-screen'
})
const isShowMapRouting = ref(false)
const routingInfo = ref([])
const handleShowMapRouting = (data: any) => {
  if (data) {
    routingInfo.value = data
  }
  isShowMapRouting.value = true
}
const handleGoBack = () => {
  if (isShowMapRouting.value) {
    isShowMapRouting.value = false
  } else {
    useRouter().back()
  }
}
</script>
